
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("aanpT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::212c07f4d8bb62a627704c63610fcace>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $766d00a109027b5e$var$_react = $766d00a109027b5e$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $766d00a109027b5e$var$_baseNew = $766d00a109027b5e$var$_interopRequireDefault((parcelRequire("3b3Iv")));
function $766d00a109027b5e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockUnlocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/lock-unlocked
 * Usage guidance:
 * Multi purpose - Known uses: unlocked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $766d00a109027b5e$var$LockUnlockedIcon = (props)=>/*#__PURE__*/ $766d00a109027b5e$var$_react.default.createElement($766d00a109027b5e$var$_baseNew.default, Object.assign({
        name: "LockUnlockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3H12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2V4a4 4 0 1 1 8 0h-1.5A2.5 2.5 0 0 0 8 1.5m-4 7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$766d00a109027b5e$var$LockUnlockedIcon.displayName = 'LockUnlockedIcon';
var $766d00a109027b5e$var$_default = module.exports.default = $766d00a109027b5e$var$LockUnlockedIcon;

});


//# sourceMappingURL=@atlaskit-internal_forge-icons--table.1da9536a.js.map
